import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDocumentsIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M6.99609 12.001L12.0261 14.241L26.9932 2.00334L15.9951 16.001L24.9951 20.001L26.995 2.00191L26.9961 2.00098L26.995 2.00152L26.9951 2.00098L26.9944 2.00183L6.99609 12.001ZM12.9984 22.0004L15.5721 16.8529C15.5847 16.8591 15.5974 16.8652 15.6103 16.8709L19.6548 18.6722L12.9984 22.0004Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M16.5 4H4.5625C3.70312 4 3 4.70312 3 5.5625V27.4375C3 28.2969 3.70312 29 4.5625 29H26.4375C27.2969 29 28 28.2969 28 27.4375V16",
		stroke: "currentColor",
		strokeWidth: 1.2,
		strokeMiterlimit: 10,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgDocumentsIcon;
